import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import Preloader from '../views/preloader'; // Must not be lazy load
import Chat from '../views/chat'; // Unable to lazy load
import Click2Call from '../views/click2call'; // Unable to lazy load
import { VIEWS } from './types';
import Logger from '../../../common/logger';

const Contact = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.contact" */ '../views/contact')
);
const CMB = React.lazy(() => import(/* webpackChunkName: "opl-wc-views.cmb" */ '../views/cmb'));
const CMBRevoke = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.cmb-revoke" */ '../views/cmb-revoke')
);
// const Chat = React.lazy(() => import(/* webpackChunkName: "opl-wc-views.chat" */ '../views/chat'));
// const Click2Call = React.lazy(() =>
//     import(/* webpackChunkName: "opl-wc-views.click2call" */ '../views/click2call')
// );
// const Click2Call = React.lazy(() => import('../views/click2call'));
const ChatSave = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.chatSave" */ '../views/save')
);
const Preview = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.preview" */ '../views/preview')
);
const Questionnaire = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.questionnaire" */ '../views/questionnaire')
);

class View extends React.Component {
    render() {
        if (!this.props.view || !this.props.mode) {
            Logger.warn('View: no view nor mode');
            return null;
        }

        let selectedView;
        switch (this.props.view.toUpperCase()) {
            case VIEWS.PRELOADER:
                selectedView = (
                    <Preloader
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig.preloadOptions}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.CONTACT:
                selectedView = (
                    <Contact
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                        options={this.props.options}
                    />
                );
                break;
            case VIEWS.CMB:
                selectedView = (
                    <CMB
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.CHAT:
                selectedView = (
                    <Chat
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.CHAT_SAVE:
                selectedView = (
                    <ChatSave
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.QUESTIONNAIRE:
                selectedView = (
                    <Questionnaire
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.CLICK2CALL:
                selectedView = (
                    <Click2Call
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig.cmbOptions}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.PREVIEW:
                selectedView = (
                    <Preview
                        mode={this.props.mode}
                        events={this.props.events}
                        viewConfig={this.props.viewConfig}
                        layerConfig={this.props.layerConfig}
                    />
                );
                break;
            case VIEWS.CMB_REVOKE:
                selectedView = <CMBRevoke events={this.props.events} />;
                break;
            default:
                return null;
        }

        if (selectedView) {
            const viewsWithoutShowingPreloader = [VIEWS.CONTACT, VIEWS.PRELOADER];
            if (viewsWithoutShowingPreloader.some(v => v === this.props.view.toUpperCase())) {
                return <Suspense fallback={null}>{selectedView}</Suspense>;
            } else {
                return (
                    <Suspense
                        fallback={
                            <Preloader
                                mode={this.props.mode}
                                events={this.props.events}
                                viewConfig={{
                                    icon: 'spinner',
                                    title: 'Widget Contact',
                                    message: 'Poczekaj chwilę...'
                                }}
                                layerConfig={this.props.layerConfig}
                            />
                        }
                    >
                        {selectedView}
                    </Suspense>
                );
            }
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        options: state.options
    };
};

export default connect(mapStateToProps)(View);
